import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { goToPrevStep, setCheckoutOverlay } from "@b/checkout/actions/ui";
import { getMainEvent } from "@b/checkout/selectors/event";
import { useTranslation } from "@c/Translations";
import { isDynamicListing } from "@b/checkout/selectors/dynamic-listing";
import { useNavigate } from 'react-router';

export const BackButton = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.ui.currentStep);
  const isSeries = useSelector((state) => !!getMainEvent(state)?.event?.isRecurring);
  const dynamicListing = useSelector((state) => !!isDynamicListing(state));

  const goBack = () => {
    if (currentStep === 0) {

      navigate(isSeries ? "/day" : "/");
      if (dynamicListing) {
        dispatch(setCheckoutOverlay(false));
      }
    } else {
      dispatch(goToPrevStep());
    }
  };

  return (
    <button
      onClick={goBack}
      className="button--clear checkout__button-back"
      role="link"
      data-href="#back"
      aria-label={t('checkout__return_to_previous_step')}
    >
      <i className="icon-arrow_back" />
    </button>
  );
};
